module.exports = __webpack_public_path__ + "img/Grace-Hopper.0f2febc8.png";